import React from "react";
import "./CertificateGroupingTVOC.scss";
import CertificateGroupingListTVOCFinalReview from "../../features/CertificateGroupingListTVOCFinalReview/CertificateGroupingListTVOCFinalReview";

const CertificateGroupingTVOCFinalReview = () => {
    return (
        <div className="analytics-page">
            <CertificateGroupingListTVOCFinalReview />
        </div>
    );
};

export default CertificateGroupingListTVOCFinalReview;